"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormToolsService = void 0;
/* eslint-disable no-continue */
const core_1 = require("@angular/core");
let FormToolsService = class FormToolsService {
    constructor() {
        this.traverseAndTransform = (o, parsingOptions) => {
            if (o) {
                for (const [key, value] of Object.entries(o)) {
                    const parsingOption = parsingOptions === null || parsingOptions === void 0 ? void 0 : parsingOptions.find((i) => i.key === key);
                    if (parsingOption) {
                        switch (parsingOption.type) {
                            case 'FLOAT':
                                o[key] = parseFloat(String(value));
                                break;
                            default:
                                o[key] = String(value);
                                break;
                        }
                    }
                    else if (value && typeof value === 'string' && /^[1-9][0-9]{0,99},[0-9]{0,4}$/.test(value)) {
                        /** Parse Float */
                        o[key] = parseFloat(value.replace(',', '.'));
                    }
                    else if (value && typeof value === 'string' && /^([1-9][0-9]{0,99})$|^0$/.test(value)) {
                        /** Parse Integer */
                        o[key] = parseInt(value.replace(/\D/g, ''), 10);
                    }
                    else if (value === undefined) {
                        /** Delete unused keys */
                        delete o[key];
                    }
                    else if (value && typeof value === 'object') {
                        /** Recursion */
                        this.traverseAndTransform(o[key], parsingOptions);
                    }
                }
            }
        };
    }
};
FormToolsService = __decorate([
    (0, core_1.Injectable)()
], FormToolsService);
exports.FormToolsService = FormToolsService;
